<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="SKU名称" prop="skuName" >
        <a-input disabled v-model="form.skuName" placeholder="请输入商品规格"/>
      </a-form-model-item>
      <a-form-model-item label="商品名称" prop="goodsId" >
        <a-select v-model="form.goodsId"  placeholder="请选择商品">
          <a-select-option disabled v-for="item in goodsList" :value="item.id" :key='item.id'>{{item.goodsName}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="商品价格" prop="price" >
        <a-input-number style="width: 150px" :min="0" v-model="form.price" placeholder="请输入商品价格" />
      </a-form-model-item>
<!--      <a-form-model-item label="商品原价" prop="originalPrice" >-->
<!--        <a-input-number style="width: 150px" :min="0" v-model="form.originalPrice" placeholder="请输入商品原价" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="需要积分数量" prop="requireScores" >-->
<!--        <a-input-number style="width: 150px" :min="0" v-model="form.requireScores" placeholder="请输入需要积分数量" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="需要现金券数量" prop="cashCoupon">
        <a-input-number style="width: 150px" :min="0" v-model="form.cashCoupon" placeholder="请输入需要现金券数量" />
      </a-form-model-item>
      <a-form-model-item label="库存" prop="stock" >
        <a-input v-model="form.stock" placeholder="请输入库存" />
      </a-form-model-item>
      <a-form-model-item label="规格图片">
        <file-upload type="image" :defaultList="form.imageArr" :count="1"
                     @input="getImg($event, 'image')"></file-upload>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSku, addSku, updateSku } from '@/api/goods/sku'
import {guid} from "@/utils/ruoyi";
import {listGoodsInfo} from "@/api/goods/goodsInfo";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      goodsList: [],
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        skuName: null,
        goodsId: null,
        stock: null,
        price: null,
        originalPrice:null,
        requireScores:null,
        cashCoupon:null,
        image: null,
        imageCount:1,
        imageArr:[],

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        skuName: [
          { required: true, message: 'sku名称不能为空', trigger: 'blur' }
        ],
        goodsId: [
          { required: true, message: '商品ID不能为空', trigger: 'change' }
        ],
        // specId: [
        //   { required: true, message: '规格ID不能为空', trigger: 'change' }
        // ],
        // specValueId: [
        //   { required: true, message: '规格属性值ID不能为空', trigger: 'change' }
        // ],
        stock: [
          { required: true, message: '库存不能为空', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '规格图片不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.initGoods()
    // this.initSpec()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    initGoods(){
      listGoodsInfo().then(res=>{
        this.goodsList = res.data
      })
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },

    // 表单重置
    reset () {
      // this.goodsList = []
      this.formType = 1
      this.form = {
        id: null,
        skuName: null,
        goodsId: null,
        specId: null,
        stock: null,
        price: null,
        originalPrice:null,
        requireScores:null,
        cashCoupon:null,
        image: null,
        imageCount: 1,
        imageArr: [],
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSku({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        let that = this
        this.form.imageArr = []
        this.form.imageArr.push({
          uid: guid(8, 10),
          name: that.form.image,
          status: 'done',
          halfUrl: that.form.image,
          url: that.form.image,
          path: that.form.image
        })
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSku(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSku(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
